<template>
    <div>
        <!-- footer two starts -->
        <div class="footer-underneath pad-50">
            <div class="centric-hold-80">
                <div class="row footer-desc">
                    <div class="col-md-4 col-sm-4 col-xs-12"><p>Call us at<br><span v-html="generateContactNumbers(clinicContactNumbers)"></span></p></div>
                    <div class="col-md-8 col-sm-8 col-xs-12"><p>Disclaimer Text<br><span>You are solely responsible for the content that you choose to submit for publication on the Website, including any feedback, ratings, or reviews relating to Practitioners or other healthcare professionals.</span></p></div>
                </div>
                <p v-if="showLinks=='y'" class="web-rights-style"> &#169; {{ new Date().getFullYear() }} DoctorSwati.com, All Rights Reserved</p>
                <p v-else class="web-rights-style"> Genamet.com, All Rights Reserved</p>
            </div>
        </div><!-- footer-underneath -->
        <!-- footer two ends -->
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
export default {
  name: "FooterBottom",
  computed: {
    ...mapGetters([
        'tenantId',
        'protocol',
        'subDomain',
        'businessId',
        'businessName',    
        'businessType',
        'businessWebsiteUrl',
        'providerFirstName',
        'providerLastName',
        'providerId',
        'providerColorCode',
        'providerPhone',
        'providerSalutation',
        'locationName',
        'clinicContactNumbers',
        'clinicAddress',
        'locationId',
        'locationTz',
        'mapUrlEmbedded',
        'clientTz',
        'loading',
        'loadingMessage',
        'error',
        'errorMessage'
    ])},
    data () {
        return {
            "showLinks": "n",
            "currentURL": ""
        }
    },
    mounted(){
        this.getURLDetails();
        console.log(this.showLinks);
    },
    methods: {
        generateContactNumbers(val){           
            console.log(val + "dodo")
            if( typeof val !== 'undefined'  && val.trim() != ""){
                let contactArray = val.split(",");
                let phoneConcat = "";
                if(Array.isArray(contactArray) === 'undefined'){
                    return '<a href="tel:' + val + '">'+ val +'</a>';
                }else{
                    let index = 0;
                    for (index = 0; index < contactArray.length; ++index) {
                        if(index == 0){
                            phoneConcat += '<a href="tel:' + contactArray[index] + '">'+ contactArray[index] +'</a>';
                        }else{
                            phoneConcat += '<br /><a href="tel:' + contactArray[index] + '">'+ contactArray[index] +'</a>';
                        }
                    }
                    return phoneConcat;
                }       
            }else{
                return "";
            } 
        },
        getURLDetails() {
            var currentUrl = window.location.hostname;
            console.log(currentUrl);
            this.currentURL = currentUrl;
            if( currentUrl.indexOf('arista') >= 0){
                this.showLinks = "y";
            }
        }
    }
};
</script>

<style>
</style>
